import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PROJECT_STATUSES, ProjectStatus, ProjectStatusOption } from '../types/project';

export const useProjectStatusSelector = (initialStatus?: ProjectStatus) => {
  const { t } = useTranslation('common');

  const options = PROJECT_STATUSES.map(status => ({
    id: status,
    label: t(`job_statuses.${status}`, { ns: 'common' }),
  }));

  const initialOption = options.find(option => option.id === initialStatus) || options[0];

  const [selectedOption, setSelectedOption] = useState<ProjectStatusOption>(initialOption);

  return {
    options,
    selectedOption,
    setSelectedOption,
  };
};
